export default __webpack_public_path__ + "static/media/vibing-zickle.636d4724.gif";